<nav class="navbar bg-body-tertiary">
  <div
    class="container-fluid d-flex justify-content-between align-items-center"
  >
    <!-- Logo -->
    <div class="icon-container">
      <img src="../../../assets/Cafler_Logo.svg" alt="Cafler Logo" />
    </div>

    <!-- Menú de navegación -->
    <ul class="navbar-nav d-flex flex-row gap-3 mb-0 me-auto">
      <li class="nav-item" *ngFor="let item of menuItems">
        <a
          class="nav-link"
          routerLinkActive="active"
          [routerLink]="item.link"
          aria-current="page"
        >
          {{ item.label | translate }}
        </a>
      </li>
    </ul>

    <div class="user-card-container" id="user-navbar">
      <div
        class="user-info-card-container"
        (click)="showUserItems = !showUserItems"
      >
        <div class="icon-user">{{ UserInicials }}</div>
        <div class="user-data-container">
          <div class="user-data-text">
            <div>{{ AccountInfo?.name }}</div>
            <div>{{ AccountInfo?.username }}</div>
          </div>
          <tui-svg src="tuiIconChevronDown"></tui-svg>
        </div>
      </div>
      <div class="user-more-options-container" *ngIf="showUserItems">
        <ng-container
          *ngFor="
            let userItem of userItems;
            let isFirst = first;
            let isLast = last
          "
        >
          <div
            class="user-item-icon"
            [ngClass]="{
              'first-item': isFirst,
              'last-item': isLast
            }"
            (click)="userItemAction(userItem.id)"
          >
            <tui-svg class="grey-icon" [src]="userItem.icon"></tui-svg>
            <div>{{ userItem.label | translate }}</div>
          </div>
          <div class="user-item-split" *ngIf="!isLast"></div>
        </ng-container>
      </div>
    </div>
  </div>
</nav>
